module.exports = require('./helpers/bundle-url').getBundleURL('fJY6H') + "match-browser.defc82cb.svg";